module.exports = __webpack_public_path__ + "img/dy-ai-park.a004728f.jpg";